import type { HsSubscriptionData } from '../types/subscription-data.type';

export class HsSubscription {
  private readonly subscribers: Set<HsSubscriptionData> = new Set<HsSubscriptionData>();
  public add(subscriber: HsSubscriptionData): void {
    this.subscribers.add(subscriber);
  }
  public unsubscribe(): void {
    for (const [subject, subscriber] of this.subscribers) {
      subject.unsubscribe(subscriber);
    }
  }
}
